import React, { Fragment, useEffect, useState } from 'react';
// import { useTranslation } from "react-i18next";
import Breadcrumb from '../../../../../components/Shared/Breadcrumb';
import ExtraRecords from '../../../../ExtraInformation/ExtraRecordsDynamicForm/BuilderExtraRecord/Tabs/ExtraRecords';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useFormRecords from '../../../../../hooks/ExtraInformation/useFormRecords';

const ExtraRecordFormPerson = () => {
  const { t, i18n } = useTranslation();
  const { PersonId } = useParams(); // ReferenceId
  //__________________________________________________
  const tableId = 'cd5aa419-0e0b-48fe-a66f-f004d97964a2'; // جدول الموظفين

  const { FormRecordWithValueList, setRefreshData } = useFormRecords(tableId, PersonId);

  const reference = JSON.parse(localStorage.getItem('ReferenceName') || '{}');

  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: 'Employees',
      link: '/HR/Employees'
    },
    {
      name: t('ExtraRecord'),
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={BcrumbList}
          subtitle={i18n.language === 'en' ? reference?.name : reference?.name2}
        />

        <div className='ms-auto'>
          <Link to='/HR/Employees' replace className='btn me-1 btn-secondary '>
            <i className='fa fa-arrow-left me-2'></i>
            {t('Back')}
          </Link>
        </div>
      </div>

      <ExtraRecords
        setRefreshData={setRefreshData}
        FormRecordWithValueList={FormRecordWithValueList}
        ReferenceId={PersonId}
      />
    </>
  );
};

export default ExtraRecordFormPerson;
